"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _default = function _default(msg, opts) {
  for (var key in opts) {
    if (typeof opts[key] === 'string') {
      opts[key] = _I18n.default.SafeString(opts[key]);
    }
  } // i18n-lint-disable-next-line require-i18n-message


  return _I18n.default.text(msg, opts);
};

exports.default = _default;
module.exports = exports.default;